import { CIcon } from '~/icons/types'

export const ciMyClassifieds: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.2 9c0-1.8-1.5-3.3-3.2-3.3h-3.9c-.1 0-.3-.1-.4-.1l-2.1-2.1c-.4-.5-1.1-.7-1.7-.7H6C4.2 2.8 2.8 4.2 2.8 6v3c-1.3.6-2.1 2-1.9 3.4l.9 6c.2 1.7 1.5 2.8 3.2 2.8h14c1.6 0 3-1.2 3.2-2.8l.9-6c.2-1.4-.6-2.8-1.9-3.4ZM4.8 6c0-.7.6-1.2 1.2-1.2h3.9c.1 0 .3.1.4.1L12.4 7c.5.5 1.1.7 1.8.7H18c.6 0 1.1.4 1.2 1H4.8V6Zm15.5 12.2c-.1.6-.6 1.1-1.2 1.1H5c-.6 0-1.1-.5-1.2-1.1l-.9-6c-.1-.7.4-1.3 1-1.4h16.2c.7.1 1.1.7 1 1.4l-.8 6Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'my-classifieds',
  type: 'regular'
}
